export function isMessagePreviewEnabled(context) {
  return context.stores.messagingConfiguration.get()?.showPreview;
}
